import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectItem, SelectProps } from '../../../components/SelectItem';
import advcashIcon from './static/img/advcash.svg';

export const Select: React.FC<SelectProps> = (props) => {
  const { t } = useTranslation('byAdvCash');

  return <SelectItem {...props} icon={advcashIcon} name={t('Advcash')} />;
};
